// isArrayNotEmpty checks to see if an array is not null, undefined or empty
export function isArrayNotEmpty<T>(arr: T[] | null | undefined): boolean {
  return Array.isArray(arr) && arr.length > 0;
}
